import Vue from 'vue';
import clientTransformer from './../../transformers/client';

const success = (client, resolve) => {
  resolve(clientTransformer.fetch(client));
};

const failed = (errors, reject) => {
  reject(errors);
};

export default (id, client) => {
  const data = client;
  return new Promise((resolve, reject) => {
    Vue.$http
      .request({
        url: `/clients/${id}`,
        data,
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  });
};



// WEBPACK FOOTER //
// ./src/app/services/client/update.js